import { FC } from 'react'
import { SaveButton, Toolbar } from 'react-admin'

export const SaveOnlyToolbar: FC<{ alwaysEnable?: boolean }> = ({ alwaysEnable }) => (
  <Toolbar>
    <SaveButton alwaysEnable={alwaysEnable} />
  </Toolbar>
)
